import React from 'react';
import { Select, Empty } from 'antd';
import { withTranslation } from "react-i18next";
import './styles.less';
class AntSelect extends Select {

    render() {
        return <Select {...this.props} notFoundContent={
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={this.props.t('action.noData')} />
        } className={`hms-ant-select ${this.props.className || ''}`}>{this.props.children}</Select>
    }
}
export const AntOption = Select.Option;
export const AntOptGroup = Select.OptGroup;
export default withTranslation()(AntSelect);